import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import keys from "../store/keys";
import { setKey } from "../store/actions";
import wantedService from "../services/wanted-item";
import moment from "moment";
import { swalError, swalSuccess, swalConfirm } from "../utils/swal";
import { useTranslation } from "react-i18next";

function WantedModeration({ session, setKey }) {
    const { t } = useTranslation();
    const [items, setItems] = useState([]);

    useEffect(() => {
        reload();
    }, []);

    const reload = async () => {
        setKey(keys.isLoading, true);
        const result = await wantedService.getAll(session.token);
        if (result.data) {
            setItems(result.data);
        } else {
            swalError(result.error);
        }
        setKey(keys.isLoading, false);
    };

    const handleDelete = (id) => {
        swalConfirm({
            callback: async () => {
                await wantedService.delete(session.token, id);
                swalSuccess(t("post_deleted"));
                reload();
            }
        });
    };

    return (
        <div className="container-fluid">
            <h2 className="mb-4 font-weight-bold">{t("wanted_moderation")}</h2>

            <div className="card shadow-sm border-0">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead className="bg-light">
                                <tr>
                                    <th>{t("col_user")}</th>
                                    <th>{t("col_title")}</th>
                                    <th>{t("col_city")}</th>
                                    <th>{t("col_budget")}</th>
                                    <th>{t("col_date")}</th>
                                    <th>{t("col_actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map(item => (
                                    <tr key={item._id}>
                                        <td>{item.user?.name}</td>
                                        <td>{item.title}</td>
                                        <td>{item.city?.title}</td>
                                        <td>{item.budgetMin} - {item.budgetMax}</td>
                                        <td>{moment(item.dateCreated).format('YYYY-MM-DD')}</td>
                                        <td>
                                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(item._id)}>{t("btn_remove")}</button>
                                        </td>
                                    </tr>
                                ))}
                                {items.length === 0 && <tr><td colSpan="6" className="text-center p-4">{t("no_wanted")}</td></tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = store => ({ session: store.session });
const mapDispatchToProps = dispatch => ({ setKey: (key, value) => dispatch(setKey(key, value)) });

export default connect(mapStateToProps, mapDispatchToProps)(WantedModeration);
